import React, { useState } from 'react'

import { CreateToolbar, AsidePreview, CreateForm } from '../containers'

export const CreateAttachment = (props: any) => {
  const {
    showAside = false,
    shouldRedirect = true,
    closeDrawer = false,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
  } = props

  const [formData, setFormData] = useState([])

  return (
    <>
      <CreateForm
        {...props}
        formTitle="Inserir Novo Anexo"
        setFormData={setFormData}
        toolbar={<CreateToolbar closeDrawer={closeDrawer} />}
        aside={showAside ? <AsidePreview formData={formData} /> : <></>}
        onSuccess={onSubmitSuccess}
        onFailure={onSubmitFailure}
        shouldRedirect={shouldRedirect}
        resource="cms/content/attachments"
      />
    </>
  )
}
